import { createRequestActionTypes } from '../../helpers'

export const FETCH_TOPICS = createRequestActionTypes(
  'HELPFUL_TOPICS',
  'FETCH_TOPICS'
)
